module.exports = __webpack_public_path__ + "static/media/HealthySleepPack3.9f2429cf.png";